import * as React from 'react';
import {connect} from 'react-redux';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {IngresoRequest} from '../../../api/mirana-api';
import {ACCESS_TOKEN} from '../../../utils/constants';
import AppAction from '../../../reduxstore/actions/action';
import {setIsAuthenticated} from '../../../reduxstore/actions/action-creators';
import IngresoForm from './ingreso-form';
import {error} from '../../../utils/notification-actions';

interface IngresoProps {
    history?: any;
    dispatch: (action: AppAction) => (any);
}

class IngresoView extends React.PureComponent<IngresoProps & RouteComponentProps<any>> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async handleSubmit(values) {
        const request: IngresoRequest = {
            username: values.usuario,
            password: values.password
        };
        try {
            const response = await this.apiClient.ingreso(request);
            localStorage.setItem(ACCESS_TOKEN, response.accessToken);
            this.props.dispatch(setIsAuthenticated(true));
            this.props.history.push('/portada');
        } catch (ex) {
            if (ex.status === 401) {
                this.props.dispatch(error('Error', 'Tu usuario o contraseña son incorrectos. Por favor intenta de nuevo'));
            } else {
                this.props.dispatch(error('Error', 'Algo inesperado ocurrió, por favor intenta de nuevo'));
            }
        }
    }

    public render() {
        return (
            <div className='account'>
                <div className='account__wrapper'>
                    <div className='account__card'>
                        <div className='account__head'>
                            <h3 className='account__title'><span className='account__logo'><div
                                className='account__logo-accent'/></span></h3>
                            <h4 className='account__subhead subhead'>Sistema de Reporter&Iacute;a</h4>
                        </div>
                        <IngresoForm onSubmit={this.handleSubmit}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(IngresoView) as any);



// WEBPACK FOOTER //
// ./src/components/pages/ingreso/ingreso.tsx